import * as Yup from 'yup';
import { omit } from 'lodash';

import { OptionType } from '@/typings/common';

import {
  CallbackFormFieldsConfig,
  CallbackFormFieldsSchema,
} from './CallbackForm.types';

export const getResultCallbackFormFields = (
  values: CallbackFormFieldsSchema,
  fieldsConfig?: CallbackFormFieldsConfig
): CallbackFormFieldsSchema => {
  const paths: Array<keyof CallbackFormFieldsSchema> = [];

  if (!fieldsConfig?.dealers?.length) {
    paths.push('dealer');
  }

  if (!fieldsConfig?.withMessage) {
    paths.push('message');
  }

  return omit(values, paths) as CallbackFormFieldsSchema;
};

export const getDefaultValues = (
  options: CallbackFormFieldsConfig | undefined
): CallbackFormFieldsSchema => {
  const dealer =
    options?.dealers && options.dealers.length === 1
      ? options.dealers[0]
      : initialCallbackFormValues.dealer;

  return {
    ...initialCallbackFormValues,
    dealer: dealer,
  };
};

export const initialCallbackFormValues: CallbackFormFieldsSchema = {
  name: '',
  phone: '',
  dealer: { label: '', value: '' },
  message: '',
};

export const getValidationCallbackFormSchema = (
  fieldsConfig?: CallbackFormFieldsConfig
): Yup.SchemaOf<CallbackFormFieldsSchema> => {
  const dealerSchema: Yup.SchemaOf<OptionType> = Yup.object({
    label: Yup.string().ensure().defined(),
    value: Yup.string().ensure().defined(),
  })
    .defined()
    .test(
      'dealer-required',
      'Выберите автоцентр',
      (dealer) =>
        !fieldsConfig?.dealers?.length || Boolean(dealer?.label && dealer?.value)
    );

  return Yup.object().shape({
    name: Yup.string().required('Введите имя'),
    phone: Yup.string().required('Введите телефон'),
    dealer: dealerSchema,
    message: Yup.string(),
  });
};
